export enum purchaseOrdersTypes {
  GET_PURCHASE_ORDERS_DEFINITIONS = '@@purchaseOrders/GET_PURCHASE_ORDERS_DEFINITIONS',
  GET_PURCHASE_ORDERS_SUCCESS = '@@purchaseOrders/GET_PURCHASE_ORDERS_SUCCESS',
  GET_PURCHASE_ORDERS_FAIL = '@@purchaseOrders/GET_PURCHASE_ORDERS_FAIL',

  GET_MILESTONESCONFIG_PO = "@PO/GET_MILESTONECONFIG",
  GET_MILESTONESCONFIG_PO_SUCCESSS = "@PO/GET_MILESTONECONFIG_SUCCESS",
  GET_MILESTONESCONFIG_PO_FAIL = "@PO/GET_MILESTONECONFIG_FAIL"
}
